import React from "react";
import "./Expertise.css";
import Flip from "react-reveal/Flip";

const Expertise = () => {
  return (
    <>
        <section id="expertise">
          <h4>
            <u>My Expertise</u>
          </h4>
          <div className="skills">
            <div className="software">
              <h5> software Developer </h5>
              <Flip top>
                <p>
                  I have a better experience with both functional and object
                  oriented programming. I am an expert in working with
                  python and javascript.
                </p>
              </Flip>
            </div>
            <div className="Frontend">
              <h5> Frontend Developer </h5>
              <Flip top>
                <p>
                  {" "}
                  I am frontend developer with a good experience in HTML,
                  CSS, JAVASCRIPT ,REACT.JS and DJANGO framework .With these tools i can
                  simply turn ideas into beautiful creations.
                </p>
              </Flip>
            </div>
            <div className="Backend">
              <h5> Backend Developer </h5>
              <Flip top>
                <p>
                  With backend development i have a very cool experience with
                  python, django framework and MySQL database .
                </p>
              </Flip>
            </div>
          </div>
        </section>
    </>
  );
};

export default Expertise;
